import styled from "@emotion/styled/macro";
import rem from "../../../../utils/rem/rem";


export const InputButtonWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding-bottom: ${rem(2)};

  input {
    margin-bottom: ${rem(0)};
    width: ${rem(285)};
  }
`;
export const InputWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding-bottom: ${rem(2)};
  gap: ${rem(16)};
  
  input {
    margin-bottom: ${rem(0)};
    width: ${rem(285)};
  }
`;